import { PAYMENT_STATUSES } from '../constants/payments.constant';

export const isPaymentProceededSuccessfully = (payment) => {
  return payment && [PAYMENT_STATUSES.SUCCESS, PAYMENT_STATUSES.TRUSTED].includes(payment.status);
};
